import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface PublicRouteProps {
  children: React.ReactNode;
}

export const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated, isInitialLoading } = useAuth();

  if (isInitialLoading) {
    return null;
  }

  if (isAuthenticated) {
    // Redirect to home page if already authenticated
    // You might want to customize this redirect based on roles if needed,
    // but typically '/' is sufficient as the ProtectedRoute at '/' handles further redirection or rendering.
    return <Navigate to="/" replace />;
  }

  return children;
};
